<div class="container">
    <div class="row">
        <div class="col-24">
            <h1 class="medium">Section 6: Completed Application</h1>
        </div>
        <div class="col-16">
            <h2 class="head2-small">Online Enrollment Confirmation # {{confirmationNumber}}</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p class="blue-text bottom-20">Thank you for your verbal agreement. Your Aetna enrollment application is now complete. Do you have a pen and paper available so that you can write down your Aetna application reference number for your records?</p>
                <p class="qtip-note bottom-20"><strong>qTip Note:</strong> Provide system-generated confirmation number.</p>
                <p class="blue-text" *ngIf="ShowCurrentYearScript">I will now submit your application to Medicare for their approval. {{spnYouenrollee}} will be mailed a letter acknowledging receipt of the application for enrollment in Aetna  within 10 calendar days. {{spnYourenrollee}} benefits will be effective beginning ({{effectiveDate}}), pending approval by Medicare. When Medicare approves {{spnIsBeneficiaryYour}} enrollment into Aetna, we’ll send {{spnyouhisher}} a confirmation letter.</p>
                <p class="blue-text" *ngIf="!ShowCurrentYearScript">I will now submit your application to Medicare for their approval. {{spnYouenrollee}} will be mailed a letter acknowledging receipt of the application for enrollment in Aetna  within 10 calendar days. {{spnYourenrollee}} benefits will be effective beginning ({{effectiveDate}}), pending approval by Medicare. When Medicare approves {{spnIsBeneficiaryYour}} enrollment into Aetna, we’ll send {{spnyouthem}} a confirmation letter.</p>
            </div>
        </div>
    </div>
    <div class="row" *ngIf ="!_global.currentUser.isCallCenterRepresentative">
        <div class="col-24" >
            <a class="link-button link print" routerLink="/enrollment/print" target="_blank" >Print a hard copy of the enrollment</a>
                <!--<button class="button primary" (click)="printHardCopy()">Print a hard copy of the enrollment Form >></button>-->
        </div>
    </div>
    <div class="row" >
        <div class="col-24">
            <a class="link-button link pdf" (click)="SavePdf()">Save PDF of Completed Enrollment Data</a>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary bottom" (click)="enrollNew()">Enroll Another client at New Address</button>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary" (click)="enrollSameAddress()">Enroll Another client at Same Address</button>
        </div>
    </div>
</div>







